export default __webpack_public_path__ + "static/media/icon-list-bullet.a727c717.svg";